import { useLocation } from "react-router-dom";

export default function Whoops404() {
    let { pathname } = useLocation();
    return (
        <div>
            <h1>Resource not found at {pathname}</h1>
        </div>
    );
}